export const transformGiftCardRequest = params => {
  const updatedParams = {
    ...params,
    status: params?.status === 'ALL' ? '*' : params.status,
  };

  if (params.email) {
    updatedParams.email = encodeURIComponent(params.email);
  } else if (params?.senderEmail) {
    updatedParams.senderEmail = encodeURIComponent(params.senderEmail);
  } else if (params?.recipientEmail) {
    updatedParams.recipientEmail = encodeURIComponent(params.recipientEmail);
  }

  return updatedParams;
};
